import type { FaireProductEntity } from "../../entity_types/product";

export const p_eb29ktggtc: FaireProductEntity = {
  token: "p_eb29ktggtc",
  type: "product",
  name: "Dog Matchbook",
  brandToken: "b_b703e67f",
  brandName: "A Shop of Things",
  imageUrl:
    "https://cdn.faire.com/fastly/032f7411f1c70e77910b782de5a534932b934a3ce601b1fe68b419a0082961db.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5c2ae8993328d2b8b27f70840df0311b86bfe8b0c7504d2f15329e7e95cb77bf.jpeg",
    "https://cdn.faire.com/fastly/d9bb19db69c434451443312cdeda23112b782a3406140fdae52d7c12f5bfd37a.jpeg",
    "https://cdn.faire.com/fastly/dd7c34e59e8d74eb63b02c96d3478f90d3f943c07ff597eb2bc6f6f4f525820f.jpeg",
    "https://cdn.faire.com/fastly/cd1595be20f6b8746b017d3ab7c4c10c710ca3b765d06ee3c6b1c264f3a37e43.jpeg",
    "https://cdn.faire.com/fastly/4699a079cd69e67d1e93e77c86a5d9264e1fc139771e09dc1191f74e76395884.jpeg",
    "https://cdn.faire.com/fastly/e241480d44d9bcce95047e80af1f4e3d1761d4902ddf081ad171a20710da1460.jpeg",
  ],
  priceDollars: 4.16,
  description:
    '\nOur newest matches feature your favorite pets!\n\nJust. Look. At. How. CUTE! Adorable dog illustrations cover this matchbook, inside and out, even on the matches themselves! Comes with 10 matches. Drawn by the talented Claire Shadomy!\n\nMatchbook is 2" x 2.25" \n\nPlease be careful when using this product and keep away from children! We can not be held liable for any accidents that occur when using this product.\n\nMade in Germany. Lighters/matches can NOT be shipped internationally.\n\nThis design is the sole property of A Shop of Things and cannot be reproduced or copied for any reason without permission beforehand. ©\n',
  tags: [],
  msrpDollars: 8.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:52.401Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
